<template>
    <b-tabs v-model="tabIndex" class="w-100">
        <b-tab title="Two Factor Authentication">
            <div class="py-4">
                <two-factor-settings></two-factor-settings>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
import TwoFactorAuthenticationSettings from '../partials/TwoFactorAuthenticationSettings';

export default {
    components: {
        'two-factor-settings': TwoFactorAuthenticationSettings,
    }
}
</script>

<style lang="scss">

</style>